import type { PersonalDeliverableTemplate } from "@/schema/personal-deliverable-template"

import { apiContextFetch, type ApiContext } from "@/hooks/api/base"

export function fetchPersonalDeliverableTemplates(context: ApiContext) {
  return apiContextFetch<PersonalDeliverableTemplate[]>(context, "personal_deliverable_templates")
}

export function createPersonalDeliverableTemplate(
  context: ApiContext,
  data: { name: string; deliverable_id: string; editor_revision: number }
) {
  return apiContextFetch<PersonalDeliverableTemplate>(context, "personal_deliverable_templates", {
    method: "POST",
    body: JSON.stringify({ personal_deliverable_template: data }),
  })
}
